import React from 'react';
import Dialog from '@mui/material/Dialog';
//import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import MultiLines from './MultiLines';
import useStyles from './Styles';

interface Props {
    mes: string,
    close():void,
    isOpen:boolean,
}

const Alert = (props:Props)=> {
    const classes = useStyles();

    return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={false}
			onClose={props.close}
		>
			<DialogContent>
                <MultiLines text={props.mes}/>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='閉じる' onClick1={props.close} bottom={0}/>
			</DialogActions>
		</Dialog>
    );
}

export default Alert;
